// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"98e334ae","14":"dddd88e6","48":"04dc7daf","146":"ccf65da3","173":"fef805db","261":"b9ad2fee","350":"f97e72f2","392":"789efc4c","705":"f75b42f1","746":"9857081f","787":"b6801e5f","796":"1de7672f","821":"5f324c6f"}[chunkId] + ".chunk.js";
};